<template>
	<div class = "keyword-tag-group">
		<div
			class="modal fade"
			id="minMaxBidBulk"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Min/Max Bid To Keyword(s)</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="bidSaving">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body main_form_block bidMinMax" v-else>
                        <p class='info' style="color:red;border:1px solid red">
                            NOTE: Max Bid Should always be greater than Min Bid and in range of {{parseBid(minBidLimit) +' to '+parseBid(maxBidLimit)}}.
                        </p>
						<div class="form-group row" style="margin-top:20px">
							<div class="col-md-2">
								<label for="min">Min Bid</label>
							</div>
							<div class = "col-md-4">
								<input type="number" class="budget-value" onkeypress="return (event.charCode >= 48 || event.charCode ==46)" v-on:keydown="fixMinMaxBidDecimal($event,'min')"  :min="minBidLimit" :max="maxBidLimit" v-model="minBid" v-on:input = "updateMinMaxBid($event,'min')" />
							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-2">
								<label for="max">Max Bid</label>
							</div>
							<div class = "col-md-4">
								<input type="number" class="budget-value" onkeypress="return (event.charCode >= 48 || event.charCode ==46)" v-on:keydown="fixMinMaxBidDecimal($event,'max')"  :min="minBidLimit" :max="maxBidLimit" v-model="maxBid" v-on:input = "updateMinMaxBid($event,'max')" />
							</div>
						</div>
						<div class="modal-footer">
                            <button class="btn btn-secondary" @click="isWrongVal = false;hideModal('cancel')" style="color: #4072a8;
								background-color: #fff;
								border: none">Cancel</button>
							<button
								type="button"
								class="btn btn-primary"
                                @click="updateBidVal()"
                                v-if = "!isWrongVal"
								>Save
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name:'BulkMinMaxBidPopUp',
    data(){
        return{
            minBid:'',
            maxBid:'',
            isWrongVal:false,
            bidSaving:false
        }
    },
    props:['minBidLimit','maxBidLimit',"keywordList"],
    computed:{
        keyWordToTagList: {
            get() {
                return this.$store.state.campaign.keyWordToTagList;
            },
            set(val) {
                this.$store.state.campaign.keyWordToTagList = val;
            }
        },
        actionSelectionControl: {
            set(val) {
                this.$store.state.campaign.actionSelectionControl = val
            },
            get() {
                return this.$store.state.campaign.actionSelectionControl
            }
        },
    },
    methods:{
		async updateBidVal(){
			let type = this.$route.params.sponsoredType
			this.bidSaving = true
			let payload = {
				sponsoredType:this.$route.params.sponsoredType
			}

			// make call to 'enable ml' first for keywords, if manually managed is true and then update its min/max bid
			let enableKeyArr = this.keyWordToTagList.filter(tagKeyword => {
				return this.keywordList.find(keyword=>{
					return (keyword.manually_managed && keyword.ams_keyword_id===tagKeyword.ams_keyword_id && keyword.id===tagKeyword.id)
				})
			});
			if(enableKeyArr && enableKeyArr.length){
				let enablePromises = []
				enableKeyArr.forEach(keyItem=>{
					let pay = {
							id:keyItem.id,
							type:type,
							ams_keyword_id:keyItem.ams_keyword_id,
							target_id: type && type=='sd'?keyItem.target_id:null
						}
					enablePromises.push(
						this.$store.dispatch("campaign/switchOffKeyword", pay)
					);
				})
				await Promise.all(enablePromises).then((ress) => {
				})
			}
			this.minBid = this.minBid?parseFloat(this.minBid):''
            this.maxBid = this.maxBid?parseFloat(this.maxBid):''
            let data = this.keyWordToTagList.map(item=>{
                return{
                    "id":item.id,"ams_keyword_id":item.ams_keyword_id||null,"sponsoredType":this.$route.params.sponsoredType,"target_id":(this.$route.params.sponsoredType && this.$route.params.sponsoredType=='sd'? item.target_id:null), "min_bid":this.minBid,"max_bid":this.maxBid
                }
            })
            payload['data'] = data
			this.$store.dispatch("campaign/bulkMinMaxBidUpdate", payload).then((resp)=>{
				if(resp){
                    this.bidSaving = false
                    this.hideModal('save')
				}
			})

		},
        hideModal(type,data){
            this.minBid = '',
            this.maxBid = '',
            this.actionSelectionControl = false
            this.$emit('closeMinMaxBidModal',type)
        },
		updateMinMaxBid(e,type){
			if(type == 'max'){
				let minVal = this.minBid
				if(minVal){
					if(parseFloat(e.target.value) < parseFloat(minVal)){
						this.isWrongVal = true
						return;
					}
					else{
						this.isWrongVal = false
					}
				}
				if((parseFloat(e.target.value) > parseFloat(this.maxBidLimit))||(parseFloat(e.target.value) < parseFloat(this.minBidLimit))){
					this.isWrongVal = true
				}
				else{
					this.isWrongVal = false
				}
			}
			else if (type == 'min'){
				let maxVal = this.maxBid
				if(maxVal){
					if(parseFloat(e.target.value) > parseFloat(maxVal)){
						this.isWrongVal = true
						return;
					}
					else{
						this.isWrongVal = false
					}
				}
				if((parseFloat(e.target.value) > parseFloat(this.maxBidLimit))||(parseFloat(e.target.value) < parseFloat(this.minBidLimit))){
					this.isWrongVal = true
				}
				else{
					this.isWrongVal = false
				}
			}
		},
        fixMinMaxBidDecimal(event,type){
			{
				debugger
				let minMaxArr = []
                if(type=='min'){
                    minMaxArr = this.minBid.toString().split('.')
                }
                else if(type=='max'){
                    minMaxArr = this.maxBid.toString().split('.')
                }
				if(minMaxArr && minMaxArr.length>1 && minMaxArr[1].length>1 && event.keyCode!=8 && event.keyCode!=46 && (event.keyCode<37 || event.keyCode >40)){
					event.preventDefault()
				}
			}
		},
		parseBid(bid){
			bid ? "":(bid = 0) 
			if(bid >=1){
				return `$${bid}`
			}
			else{
				return `${bid * 100}¢`
			}
		},
    }
}
</script>
<style lang='scss'>
.bidMinMax {
    .info{
        font-size:12px;padding:4px;border:1px solid black;margin-bottom:auto;
    }
}
</style>